<script>
  import { getContext, setContext as baseSetContext } from 'svelte'
  import { fade } from 'svelte/transition'
  import { trapFocus } from '../trapFocus.js'

  let modalSize

  let cssBg,
    cssContent,
    currentTransitionBg,
    modalContentClassName,
    isNeptuneModal,
    isModalLarge,
    position,
    modalContentKb,
    isModalDialog,
    modalName

  export let key = 'kudobuzz-modal'
  export let closeButton = true
  export let closeOnEsc = true
  export let closeOnOuterClick = true
  export let styleBg = { top: 0, left: 0 }
  export let styleWindow = {}
  export let styleContent = {}
  export let setContext = baseSetContext
  export let transitionBg = fade
  export let transitionBgProps = { duration: 250 }
  export let transitionWindow = transitionBg
  export let transitionWindowProps = transitionBgProps

  const defaultState = {
    closeButton,
    closeOnEsc,
    closeOnOuterClick,
    styleBg,
    styleWindow,
    styleContent,
    transitionBg,
    transitionBgProps,
    transitionWindow,
    transitionWindowProps,
    isNeptuneModal,
    isModalLarge,
    position,
    isModalDialog,
    modalName
  }
  let state = { ...defaultState }

  let Component = null
  let props = null

  let background
  let wrap

  const camelCaseToDash = str =>
    str.replace(/([a-zA-Z])(?=[A-Z])/g, '$1-').toLowerCase()

  const toCssString = props =>
    Object.keys(props).reduce(
      (str, key) => `${str}; ${camelCaseToDash(key)}: ${props[key]}`,
      ''
    )

  $: cssBg = toCssString(state.styleBg)
  $: cssContent = toCssString(state.styleContent)
  $: currentTransitionBg = state.transitionBg
  $: modalContentClassName = state.isNeptuneModal
    ? 'kb-modal__neptune-content'
    : 'kb-modal__content'
  $: modalSize = state.isModalLarge ? 'kb-modal--large' : 'kb-modal--small'
  $: modalName = state.modalName || ''

  $: if (modalContentKb && state.position) {
    if (window.location !== window.parent.location) {
      if (window.matchMedia('(min-width: 440px)').matches) {
        modalContentKb.style.position = 'fixed'
      } else if (window.matchMedia('(max-width: 440px)').matches) {
        modalContentKb.style.position = 'absolute'
        modalContentKb.style.width = '100%'
      }
    }
  }

  const toVoid = () => {}
  let onClose = toVoid
  let onClosed = toVoid

  const open = (NewComponent, newProps = {}, options = {}, callback = {}) => {
    Component = NewComponent
    props = newProps
    state = { ...defaultState, ...options }
    onClose = callback.onClose || toVoid
    onClosed = callback.onClosed || toVoid
  }

  const { start: autorotateStartSliderCarousel } =
    getContext('carousel-autorotate-method') || {}

  const close = (callback = {}) => {
    onClose = callback.onClose || onClose
    onClosed = callback.onClosed || onClosed
    Component = null
    props = null

    modalName === 'slider modal' && autorotateStartSliderCarousel()
  }

  const handleKeyup = ({ key }) => {
    if (state.closeOnEsc && Component && key === 'Escape') {
      event.preventDefault()
      close()
    }
  }

  const handleOuterClick = event => {
    if (
      state.closeOnOuterClick &&
      (event.target === background || event.target === wrap)
    ) {
      event.preventDefault()
      close()
    }
  }

  setContext(key, { open, close })
</script>

<style>
  * {
    box-sizing: border-box;
  }

  :global(.kb-modal__background-3XMprJ) {
    position: fixed;
    z-index: 10000;
    display: flex;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    background: rgba(97, 97, 117, 0.38);
  }

  .kb-modal__content {
    background: #fff;
    box-shadow: 0 31px 46px 0 rgba(95, 95, 95, 0.14);
    border-radius: 10px;
    margin: auto;
    overflow: hidden;
  }

  .kb-modal--small {
    width: 480px;
  }

  .kb-modal--large {
    width: 667px;
    max-height: 700px;
  }

  .kb-modal__neptune-content {
    width: 490px;
    background: #fff;
    border-radius: 3px;
    margin: auto;
    box-shadow: 0 37px 35px 0 rgba(16, 37, 62, 0.22),
      0 0 15px 0 rgba(0, 0, 0, 0.09);
    position: relative;
  }

  :global(.button__close-3MMQUI) {
    display: block;
    box-sizing: border-box;
    position: relative;
    background: transparent;
    z-index: 1000;
    top: 1rem;
    right: 1.2rem;
    float: right;
    margin: 0;
    padding: 0;
    width: 1.5rem;
    height: 1.5rem;
    border: 0;
    color: black;
    box-shadow: none !important;
  }

  :global(.button__close-3MMQUI::before,)
  :global(.button__close-3MMQUI::after) {
    content: '';
    display: block;
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    width: 1rem;
    height: 1px;
    background: black;
    transform-origin: center;
    transition: height 0.2s cubic-bezier(0.25, 0.1, 0.25, 1),
      background 0.2s cubic-bezier(0.25, 0.1, 0.25, 1);
  }

  :global(.button__close-3MMQUI::before) {
    -webkit-transform: translate(0, -50%) rotate(45deg);
    -moz-transform: translate(0, -50%) rotate(45deg);
    transform: translate(0, -50%) rotate(45deg);
    left: 0.25rem;
  }

  :global(.button__close-3MMQUI::after) {
    -webkit-transform: translate(0, -50%) rotate(-45deg);
    -moz-transform: translate(0, -50%) rotate(-45deg);
    transform: translate(0, -50%) rotate(-45deg);
    left: 0.25rem;
  }

  :global(.button__close-3MMQUI:hover) {
    cursor: pointer;
  }

  :global(.button__close-3MMQUI:hover::before,)
  :global(.button__close-3MMQUI:hover::after) {
    cursor: pointer;
  }

  :global(.button__close-3MMQUI:active) {
    transform: scale(0.9);
  }

  :global(.button__close-3MMQUI:hover,)
  :global(.button__close-3MMQUI:focus) {
    outline: 0;
    box-shadow: 0 0 8px 3px rgba(128, 128, 128, 0.8) !important;
  }
</style>

<svelte:window on:keyup={handleKeyup} />

<div>
  {#if Component}
    <div
      class="kb-modal__background-3XMprJ"
      on:click={handleOuterClick}
      bind:this={background}
      transition:currentTransitionBg={state.transitionBgProps}
      style={cssBg}>
      <!-- svelte-ignore a11y-autofocus -->
      <div
        role="dialog"
        aria-label={modalName}
        aria-modal={state.isModalDialog && 'true'}
        class="{modalContentClassName}
        {modalSize}"
        bind:this={modalContentKb}
        style="{cssContent}{state.position && state.position}"
        tabindex={0}
        autofocus
        use:trapFocus>
        <button
          on:click={close}
          class="button__close-3MMQUI"
          aria-label="close modal" />
        <svelte:component this={Component} {...props} />
      </div>
    </div>
  {/if}
  <slot />
</div>
